

<ng-template #productAccordionItemHeader let-data>
    <div class="col-sm-2 icon-div" *ngIf="!product['parts']">
        <span class="icon-span"><i class="fas fa-prescription-bottle"></i></span>
    </div>
    <div class="col-sm-2 icon-div" *ngIf="product['parts']">
        <span class="icon-span"><i class="fas fa-medkit"></i></span>
    </div>
    <div class="col-sm-10">
        <div class="col-sm-12 sidebar-item-div">
            <span aria-label="Proprietary name"> Proprietary Name</span>
        </div>
        <div class="col-sm-12 sidebar-item-div product-name">
            <span [attr.aria-label]="product.proprietaryName">{{product.proprietaryName}}</span>
        </div>
    </div>
</ng-template>

<ng-template #productAccordionItemContent>
    <div *ngFor="let part of product['parts']; let i = index" class="col-sm-12">
        <div class="col-sm-2"></div>
        <div class="col-sm-10 sidebar-sub-item-div part-name" (click)="showPartItem()" tabindex="0" (keydown.enter)="showPartItem()" role="button">
            <span [attr.aria-label]="'Part ' + i+1">Part {{i+1}}</span>
        </div>
    </div>

    <div class="col-sm-12 product-menu">
        <!-- <hr> -->
        <div class="col-sm-6 text-left pull-left">
            <a href="javascript:void(0);" role="link" aria-label="clone product" tabindex="0"><i class="fas fa-copy"></i>clone product</a>
        </div>
        <div class="col-sm-6 text-right pull-left" *ngIf="!product['parts']">
            <a href="javascript:void(0);" (click)='deleteProductItem()' class='delete-link'><i class="fas fa-times"
                    aria-hidden="true" tabindex="0" role="link" aria-label="delete product" (keydown.enter)="deleteProductItem()"></i>delete product</a>
        </div>
        <div class="col-sm-6 text-right" *ngIf="product['parts']">
            <a href="javascript:void(0);" role="link" aria-label="delete kit" tabindex="0"><i class="fas fa-times" aria-hidden="true"></i>delete kit</a>
        </div>
    </div>
</ng-template>
